import { memo } from 'react';
import clsx from 'clsx';

type Props = {
    /** `lg` matches the per-selection subtotal, `sm` the toolbar summary total. */
    size?: 'sm' | 'lg';
}

/**
 * Placeholder for a price that is still being calculated. It keeps the slot at the size of the
 * number that lands in it, so filling the prices in does not move the rest of the row.
 */
export const SkeletonPrice = memo(({ size = 'sm' }: Props) => (
    <span
        className={clsx('vss-skeleton-price', `vss-skeleton-price--${size}`)}
        aria-hidden={true}
    />
));
